import { nameMatches } from "./nameMatches";

/** How many Circles instant search lists. */
const CIRCLE_RESULTS = 5;

/** Circles whose name matches what's being typed, for instant search. */
export function searchCircles<C extends { name: string }>(text: string, circles: C[]): C[] {
  return circles.filter((circle) => circle.name && nameMatches(circle.name, text)).slice(0, CIRCLE_RESULTS);
}
